import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import { indexPresetQuestions } from './asyncActions'

const biPresetQuestionSlice = createSlice({
  name: 'bi_preset_question',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [indexPresetQuestions.fulfilled](state, action) {
      state.records = action.payload
    },
  },
})

export default biPresetQuestionSlice
